import { useQueryClient } from "@tanstack/react-query";
import { PropsWithChildren, useCallback, useMemo } from "react";
import { queryKeys } from "../../api";
import { useGenericContext } from "../../hooks";
import { AwsFile } from "../../models";
import { IAwsFilesContext, AwsFilesContext } from ".";

export const AwsFilesProvider = (props: PropsWithChildren) => {
    const queryClient = useQueryClient();

    const awsFiles = useMemo<AwsFile[] | undefined>(
        () => queryClient.getQueryData<AwsFile[]>(queryKeys.awsFiles.all()),
        [queryClient]
    );

    const clearAwsFiles = useCallback(() => {
        queryClient.removeQueries(queryKeys.awsFiles.all());
    }, [queryClient]);

    const value = useMemo<IAwsFilesContext>(
        () => ({
            awsFiles,
            clearAwsFiles,
        }),
        [awsFiles, clearAwsFiles]
    );

    return <AwsFilesContext.Provider value={value} {...props} />;
};
